import TxActivityLabel from './TxActivityLabel';

export default TxActivityLabel;
